
export const newArrivalSlider = [
  "https://www.netmeds.com/images/cms/aw_rbslider/slides/1658299761_Huggies_mini-banners-web.jpg",
  "https://www.netmeds.com/images/cms/aw_rbslider/slides/1658244942_Sahyog_mini-banners-web.jpg",
  "https://www.netmeds.com/images/cms/aw_rbslider/slides/1658245151_Hicks_mini-banners-web.jpg",
  "https://www.netmeds.com/images/cms/aw_rbslider/slides/1654696818_Healthvit_436-px-224px-home-page.jpg",
  "https://www.netmeds.com/images/cms/aw_rbslider/slides/1657800082_Mini-banner_web.jpg",
];